/** Replace hyphens and spaces with underscores */
export function formatROILabel(label: string) {
  return label.trim().replace(/[-\s]/g, '_');
}
